export default __webpack_public_path__ + "static/media/LOGO_LBF.737fd132.png";